const API_BASE_URL = process.env.REACT_APP_API_URL || 
                     "https://mri.host1.dataonmatrix.net";
const ASSETS_BASE_URL = process.env.REACT_FRONTEND_URL || 
                     "https://mri.host1.dataonmatrix.net";

const BaseUrl = API_BASE_URL;
const AnimationBaseUrl = `${ASSETS_BASE_URL}/assets/animations/`;
const FontBaseUrl = `${ASSETS_BASE_URL}/assets/fonts/`;
const ImgBaseUrl = `${ASSETS_BASE_URL}/assets/images/`;
const VideoBaseUrl = `${ASSETS_BASE_URL}/assets/videos/`;
const siteUrl = API_BASE_URL;
const companyLogo = `${ASSETS_BASE_URL}/logo.svg`;

// API Configuration
const API_KEY = process.env.REACT_APP_API_KEY || 
                "dummyApiKey";
// Remove /api suffix if present (we add it in services)
const cleanBaseUrl = API_BASE_URL.replace(/\/api\/?$/, '');

module.exports = {
  BaseUrl,
  AnimationBaseUrl,
  FontBaseUrl,
  ImgBaseUrl,
  VideoBaseUrl,
  siteUrl,
  companyLogo,
  API_BASE_URL: cleanBaseUrl,
  API_KEY,
};
